<template>
  <div class="background-01">
    <v-layout row wrap>
      <v-flex xs12 sm1 class="hidden-xs-only">
        <image-app class="animated fadeInLeft" :imaSize="100" imaSrc="design/gray-arrow" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm7 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="¿Cuáles son sus metas a…" titleLevel="h1">
          <template slot="partOne">¿Cuáles<br></template>
          <template slot="partTwo">son sus </template>
          <template slot="partThree"> metas a…</template>
        </ui-title-one>
      </v-flex>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'¿Cuáles son sus metas?'" videoEmbed="ADMINISTRACIONDINERO06MetasEnElTiempo.mp4"></ui-simple-lsc>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center mt-5>
      <v-flex xs12 sm5 md4 class="animated fadeInLeft dura_2">
        <ui-list bullet="bullet-dav" :lista="lista"></ui-list>
      </v-flex>
      <v-flex xs12 sm4 md4 class="animated fadeInDown dura_3 aligner">
        <p>
          Si aún no tiene claras sus <strong>metas, este es el mejor momento</strong> para empezar a hacerlo.<br><br>
          <strong>Dedíquele unos cuantos minutos</strong> y verá cómo sus <strong>decisiones</strong> se vuelven más <strong>efectivas</strong>.
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      lista: [
        "<spant class='font-red'>…30</spant> días?",
        "<spant class='font-red'>…3</spant> meses?",
        "<spant class='font-red'>…12</spant> meses?",
        "<spant class='font-red'>…3</spant> años?"
      ]
    };
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-06.vue?0a8fd2bc